import { Grid } from "@mantine/core";
import React, { useEffect, useState } from "react";
import FDTGrid18 from "../../common/FDTGrid18";
import FDTSymbolsLegend from "../../../common/extra-tests/fdt/FDTSymbolsLegend";
import { EyeDisplacement, FDTTestResult } from "types/testTypes";
import GazeTrackMap from "@components/test_entry/GazeTrackMap";
import { transformFDTResult } from "@utils/TestUtils";

export default function FDTScreeningTestEntry({ entry }) {
  const result = transformFDTResult(entry) as FDTTestResult | null;

  const [degree, setDegree] = useState("20");
  const [displacements, setDisplacements] = useState<EyeDisplacement[]>(null);

  useEffect(() => {
    if (result?.testType) {
      setDegree(result.testType.split("-")[1].replace(/-[15]/, ""));
    }
    if (result?.displacementList) {
      setDisplacements(result.displacementList);
    }
  }, [result]);

  return (
    <Grid>
      <Grid.Col span={8} p={"xl"}>
        {result && (
          <FDTGrid18
            eye={result?.eye}
            degree={degree}
            data={result?.fdtPoints}
            fovea={result?.fovea}
            withBorder
            testType={result?.testType}
            displayImage={true}
          />
        )}
        {displacements && <GazeTrackMap data={displacements} />}
      </Grid.Col>
      <Grid.Col span={4}>
        {result && <FDTSymbolsLegend cols={1} spacing={"xs"} larger testType={result?.testType} />}
      </Grid.Col>
    </Grid>
  );
}
